module.exports = __webpack_public_path__ + "static/media/SFProDisplay-Regular.d09549c1.ttf";